var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1514 6.42859H14.5968L17.3195 13.2353L13.9161 15.2773C15.374 18.2335 17.7666 20.6261 20.7228 22.0841L22.7648 18.6807L29.5716 21.4034V26.8488C29.5716 27.5709 29.2847 28.2634 28.7741 28.774C28.2635 29.2846 27.571 29.5714 26.8489 29.5714C21.5386 29.2487 16.5301 26.9937 12.7683 23.2319C9.00642 19.4701 6.75142 14.4615 6.42871 9.15128C6.42871 8.42918 6.71556 7.73665 7.22617 7.22605C7.73677 6.71544 8.4293 6.42859 9.1514 6.42859",
    stroke: "#2E81F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f159cbc0.svg";
export { ForwardRef as ReactComponent };